export default {
    subTitle: 'Unknown error',
    title: 'Oops! Something went wrong',
    description: 'Our programmers are already looking for a problem. As soon as we fix it, the site will work normally.',
};
